import { render, staticRenderFns } from "./bk-frame.vue?vue&type=template&id=f4bfef82"
import script from "./bk-frame.vue?vue&type=script&lang=js"
export * from "./bk-frame.vue?vue&type=script&lang=js"
import style0 from "./bk-frame.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./_common/components/bk-frame.vue
// module id = f0Sf
// module chunks = 0